import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button } from "@/components/ui/button";
import { GripVertical, X } from "lucide-react";

/**
 * Sürüklenebilir Modal Bileşeni
 * Kullanıcı başlık çubuğundan tutarak modalı sürükleyebilir
 */
const DraggableModal = ({ isOpen, onClose, title, children, maxWidth = "max-w-2xl" }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef(null);
  const startPos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (isOpen) {
      setPosition({ x: 0, y: 0 });
    }
  }, [isOpen]);

  const handleMouseDown = (e) => {
    if (e.target.closest('.drag-handle')) {
      setIsDragging(true);
      startPos.current = {
        x: e.clientX - position.x,
        y: e.clientY - position.y
      };
    }
  };

  const handleMouseMove = useCallback((e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - startPos.current.x,
        y: e.clientY - startPos.current.y
      });
    }
  }, [isDragging]);

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, handleMouseMove]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay - Arka plan karartma (ayrı katman) */}
      <div 
        className="fixed inset-0 bg-black/50 z-[9998]" 
        onClick={onClose} 
      />
      {/* Modal Container - Overlay'in üstünde */}
      <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none">
        <div
          ref={dragRef}
          className={`relative ${maxWidth} w-full mx-4 bg-white rounded-lg shadow-2xl max-h-[90vh] overflow-hidden pointer-events-auto`}
          style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
          onMouseDown={handleMouseDown}
        >
          {/* Drag Handle Header */}
          <div className="drag-handle flex items-center justify-between px-4 py-3 bg-gray-100 border-b cursor-move select-none">
            <div className="flex items-center gap-2">
              <GripVertical className="h-5 w-5 text-gray-400" />
              <h3 className="font-semibold text-gray-800">{title}</h3>
            </div>
            <Button variant="ghost" size="sm" onClick={onClose} className="h-8 w-8 p-0">
              <X className="h-4 w-4" />
            </Button>
          </div>
          
          {/* Content */}
          <div className="p-4 overflow-y-auto max-h-[calc(90vh-60px)]">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default DraggableModal;
